import { render, staticRenderFns } from "./DeleteMarketBlacklist.vue?vue&type=template&id=0ea7819b"
import script from "./DeleteMarketBlacklist.vue?vue&type=script&lang=js"
export * from "./DeleteMarketBlacklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports